// @ts-strict-ignore
import { FilterState } from './reducer'
import { useRouter } from 'next/router'
import * as qs from 'query-string'
import { useEffect, useRef } from 'react'

export function useUrlSync(state: FilterState, fixedFilters) {
  const router = useRouter()
  const isMounted = useRef(false)
  const { page, sort, filters, brands, collections } = state
  const previousAsPath = useRef<string>()
  let query = {
    ...state.filters,
  }
  // Don't sync attributes that are fixed
  Object.keys(fixedFilters).forEach((key) => delete query[key])

  if (page && page > 1) {
    query['page'] = page
  }
  if (sort) {
    query['sort'] = sort
  }
  if (brands && brands.length) {
    query['brands'] = brands
  }
  if (collections && collections.length) {
    query['collections'] = collections
  }

  const { asPath } = router

  useEffect(() => {
    previousAsPath.current = asPath
  }, [asPath])

  useEffect(() => {
    if (!isMounted.current) {
      return
    }
    const newParams = qs.stringify(query, { arrayFormat: 'comma' })
    const oldParams = window.location.search.replace('?', '')
    // Only replace route if we're on the same asPath and params did change
    if (previousAsPath.current === router.asPath && newParams !== oldParams) {
      router.replace(
        {
          pathname: router.asPath.split('?')[0],
          query: newParams,
        },
        undefined,
        {
          shallow: true,
        },
      )
    }
  }, [page, sort, filters, brands, collections]) // eslint-disable-line

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true
    }
  }, [])
}
